// Makers chimera returns url-like id, the difference is in the "-" instead of "_".
// Need to adapt such ids to continue work with others pages like brief
export const convertTagPageId = (tagId) => tagId.replace(/-/g, '_');
